import { render, staticRenderFns } from "./SearchSortingList.vue?vue&type=template&id=c4296082&scoped=true&"
import script from "./SearchSortingList.vue?vue&type=script&lang=js&"
export * from "./SearchSortingList.vue?vue&type=script&lang=js&"
import style0 from "./SearchSortingList.vue?vue&type=style&index=0&id=c4296082&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4296082",
  null
  
)

export default component.exports